import React from 'react';
import Logo from '../Logo';
import data from '../logos/hsbc-hexagon.js';

const LogoHsbcHexagon = (props) => <Logo {...props} data={data} />;

LogoHsbcHexagon.displayName = 'LogoHsbcHexagon';

export default LogoHsbcHexagon;
